// src/utils/uploadImage.js
const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

// Har section ka display size. Ye URL mein lagta hai (upload mein nahi).
// c_fill = exact size par crop | c_limit = crop nahi, sirf fit
export const IMAGE_SIZES = {
  homeHero:     "c_limit,w_1920,h_1080",
  aboutHero:    "c_fill,w_1920,h_800,g_auto",
  admBanner:    "c_fill,w_1920,h_600,g_auto",
  banner:       "c_fill,w_1920,h_600,g_auto",
  gallery:      "c_fill,w_1200,h_800,g_auto",
  campus:       "c_fill,w_1200,h_800,g_auto",
  schoolLife:   "c_fill,w_1200,h_800,g_auto",
  resultImages: "c_fill,w_1200,h_900,g_auto",
  team:         "c_fill,w_800,h_800,g_face",
  alumni:       "c_fill,w_800,h_800,g_face",
  popup:        "c_fill,w_800,h_1000,g_auto",
};

// Original file upload karta hai. Koi transformation nahi bheji jati (unsigned preset ki wajah se).
export const uploadImageToCloudinary = async (file) => {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error(
      ".env values not loaded. Check .env file and restart with npm start"
    );
  }
  if (!file) throw new Error("No file selected");
  if (!file.type.startsWith("image/")) throw new Error("Only images allowed");
  if (file.size > 5 * 1024 * 1024) throw new Error("Image must be under 5MB");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);
  formData.append("folder", "school_website");

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: "POST", body: formData }
  );

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.error?.message || "Cloudinary upload failed");
  }

  return { url: data.secure_url, publicId: data.public_id };
};

// Section key ke hisaab se sahi size ki URL (crop + fit + optimize).
// sizeKey na ho to sirf optimize karta hai.
export const sizedUrl = (url, sizeKey) => {
  if (!url) return "";
  const size = IMAGE_SIZES[sizeKey];
  const parts = [size, "f_auto", "q_auto"].filter(Boolean).join(",");
  return url.replace("/upload/", `/upload/${parts}/`);
};

// Purana helper, chhoti thumbnails ke liye (width based)
export const optimizeUrl = (url, width = 800) =>
  url ? url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`) : "";